module.exports = __webpack_public_path__ + "static/img/patientlist.1b30c18f.png";